/**
 * Peticiones que pertenecen al propio trámite de ENTRAR (o de salir) y a la carga
 * de recursos estáticos de la app.
 *
 * Por qué existe: con la sesión terminada (la credencial almacenada es la que el
 * back rechazó) el front deja de mandar peticiones, porque cada una volvería
 * rechazada. Pero estas tienen que seguir pasando: sin ellas no se puede volver a
 * entrar, y sin los diccionarios de idioma el aviso mostraría la clave en vez del
 * texto (feature 33, R5/R9).
 *
 * ⚠️ `/token/refresh/` NO es de acceso a propósito: con la sesión muerta el
 * refresco solo produce otro rechazo.
 *
 * Puro: cero Angular. Se compara contra la RUTA (sin query ni fragmento) para que
 * un parámetro como `?next=/assets/` no convierta en "de acceso" a cualquier URL.
 */
const RUTAS_DE_ACCESO: readonly string[] = [
  '/api/users/auth/login/',
  // Se busca como SUBCADENA de la ruta (`includes`, no prefijo: la URL trae el host
  // absoluto). Cubre `verify/` y `verify-code/` (y cualquier paso del mismo trámite).
  '/api/users/auth/2fa/',
  '/api/users/auth/handoff/',
  '/api/users/auth/logout/',
];

/** Diccionarios de Transloco y demás estáticos: los pide `HttpClient`. */
const PREFIJO_ESTATICOS = /^(?:[a-z][a-z0-9+.-]*:\/\/[^/]+)?\/?assets\//i;

/** Corta la query y el fragmento: la decisión es por ruta. */
function rutaDe(url: string): string {
  const corte = url.search(/[?#]/);
  return corte === -1 ? url : url.slice(0, corte);
}

export function esPeticionDeAcceso(url: string): boolean {
  const ruta = rutaDe(url);
  if (PREFIJO_ESTATICOS.test(ruta)) {
    return true;
  }
  return RUTAS_DE_ACCESO.some((prefijo) => ruta.includes(prefijo));
}
